import { UseQueryResult } from '@tanstack/react-query';
import { TrialState } from '../models/TrialState';
import { trialStatesIncludesActiveTrials } from './trialStatesIncludesActiveTrials';

export const sitesTrialStatesQueriesIncludesActiveTrials = (
  queryResults: Array<UseQueryResult<Array<TrialState>>>
): boolean => {
  const sitesTrialV2States = queryResults
    .map((queryResult) => queryResult.data)
    .filter((trialStates) => trialStates);

  return sitesTrialV2States.some((siteTrialV2States) =>
    trialStatesIncludesActiveTrials(siteTrialV2States)
  );
};
